module.exports = __webpack_public_path__ + "static/media/ourGoalRocket.34ec9bbb.svg";